import { styled } from "@mui/material/styles";
import { Form } from "formik";
import { InfoNote as BaseInfoNote } from "../../../../components/InfoNote";

export const InfoNoteStyled = styled(BaseInfoNote)({
  marginTop: "10px",
  textAlign: "left"
});

export const FormStyle = styled(Form)(({ theme }) => ({
  width: "100%",
  "& .MuiGrid-root": {
    "&> .MuiGrid-item": {
      paddingTop: "24px"
    }
  }
}));
